import AllDone2SVG from "components/svg/all-done-2";
import { Button as CustomButton } from "../styled";

export function StepSuccess() {
  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", margin: "100px 0px" }}>
      <AllDone2SVG />
      <h1 style={{ fontSize: "20px", fontWeight: "600", lineHeight: "160%", textAlign: "center", color: "#0F0F1E99" }}>Os dados foram confirmados e enviados com sucesso.</h1>
      <CustomButton
        variant="outlined"
        onClick={() => window.location.reload()}
        style={{ width: "100%", maxWidth: "600px", marginTop: "20px"}}
      >
        Voltar para o início
      </CustomButton>
    </div>
  );
}
